// @ngInject
function EditDeliveryPlanningDialogService($uibModal) {

    return {
        showDialog: showDialog
    };

    function showDialog(deliveryPlanTemplate) {

        var modalDefaults = {
            backdrop: 'static',
            keyboard: true,
            controller: 'EditDeliveryPlanningDialogController as vm',
            templateUrl: 'main/order/orderdeliveryplanning/editDeliveryPlanningDialog/editDeliveryPlanningDialog.tpl.html',
            size: 'lg'
        };

        modalDefaults.resolve = {
            deliveryPlanTemplate: function() {
                return deliveryPlanTemplate;
            },
        };

        return $uibModal.open(modalDefaults).result;
    }
}

// @ngInject
function EditDeliveryPlanningDialogController($uibModalInstance, deliveryPlanTemplate) {
    var vm = this;

    vm.deliveryPlanTemplate = deliveryPlanTemplate;
    vm.deliveryPlanTemplateCopy = angular.copy(vm.deliveryPlanTemplate);

    vm.closeModal = closeModal;
    vm.getRowStyle = getRowStyle;
    vm.formatDate = formatDate;
    vm.setLeadTime = setLeadTime;
    vm.recalcLeadTime = recalcLeadTime;
    vm.changeDateAfterLeadTime = changeDateAfterLeadTime;
    vm.errorLeadTime = errorLeadTime;

    recalcLeadTime();

    function closeModal(keepChanges) {
        if(keepChanges)
            $uibModalInstance.close(vm.deliveryPlanTemplate);
        else
            $uibModalInstance.close(false);
    }

    function errorLeadTime(leadTimeInDays){
        var style = {};
        
        if(leadTimeInDays < 0){
            style['background-color'] = 'lightpink';
            style['border-color'] = 'red';
        }
        else{
            style['background-color'] = 'whitesmoke';
            style['border-color'] = 'lightgray';
        }

        return style;       
    }

    function getRowStyle(plan){
        var style = {};
        if(plan !== undefined){
            if(plan.disabled){
                style['background-color'] = 'lightgrey';
                style['color'] = 'gray';
            }
        }
        return style;
    }

    function changeDateAfterLeadTime(plan){
        if(plan.leadTimeInDays < 0)
            plan.leadTimeInDays = 0;

        var index = _.findIndex(vm.deliveryPlanTemplate, function(p){
            if(p.id === plan.nextPlanId){
                return true;
            }
        });

        if(index !== -1){
            var newDate = new Date(plan.plannedDate.valueOf());
            vm.deliveryPlanTemplate[index].plannedDate.setDate(newDate.getDate() + plan.leadTimeInDays);
            console.log(vm.deliveryPlanTemplate[index].plannedDate);
            changeDateAfterLeadTime(vm.deliveryPlanTemplate[index]);
        }
    }

    function setNextId(plan){
        if(plan.disabled)
            return null;

        var sortAdd = 1;
        var nextPlan = _.find(vm.deliveryPlanTemplate, function(p){
            if(p.sortOrder === plan.sortOrder + sortAdd){
                if(p.disabled)
                    sortAdd++;
                else
                    return true;
            }
        });

        if(nextPlan === undefined)
            return null;

        plan.leadTimeInDays =  daysBetween(plan.plannedDate, nextPlan.plannedDate);
        return nextPlan.id;
    }

    function recalcLeadTime(){
        _.forEach(vm.deliveryPlanTemplate, function(plan){
            plan.nextPlanId = setNextId(plan);
            /*
            if(!plan.disabled && plan.nextPlanId !== null)
            {
                var nextPlan = _.find(vm.deliveryPlanTemplate, function(p){
                    if(p.id === plan.nextPlanId){
                        return true;
                    }
                });
                plan.leadTime = daysBetween(plan.plannedDate, nextPlan.plannedDate);
            }*/
        });
    }

    function setLeadTime(plan){
        if(plan.disabled)
            return;

        var nextStage = _.find(vm.deliveryPlanTemplate, function(stage){
            if(stage.id === plan.nextPlanId)
                return true;
        });
        var prevStage =_.find(vm.deliveryPlanTemplate, function(stage){
            if(stage.nextPlanId === plan.id)
                return true;
        });

        if(nextStage !== undefined){
            if(nextStage.disabled)
                setLeadTime(nextStage);   
            else
                plan.leadTime = daysBetween(plan.plannedDate, nextStage.plannedDate);
        }
        else{      
            plan.leadTime =  0;
        }

        if(prevStage !== undefined){
            prevStage.leadTime =  daysBetween(prevStage.plannedDate, plan.plannedDate);
            if(prevStage.disabled)
                setLeadTime(prevStage);
        }
    }

    function treatAsUTC(date) {
        var result = new Date(date);
        result.setMinutes(result.getMinutes() - result.getTimezoneOffset());
        return result;
    }
    
    function daysBetween(startDate, endDate) {
        var millisecondsPerDay = 24 * 60 * 60 * 1000;
        return Math.round((treatAsUTC(endDate) - treatAsUTC(startDate)) / millisecondsPerDay);
    }

    function formatDate(date) {
        if(date === null)
            return date;
        if(angular.isNumber(date)){
            date = new Date(date);
        }
        const offset = date.getTimezoneOffset()
        date = new Date(date.getTime() - (offset*60*1000))
        return date.toISOString().split('T')[0]
    }
}

angular
    .module('order.deliveryPlanning.editDeliveryPlanningDialog', [])
    .service('EditDeliveryPlanningDialogService', EditDeliveryPlanningDialogService)
    .controller('EditDeliveryPlanningDialogController', EditDeliveryPlanningDialogController);
